<template>
  <div>
    <Head :title="form.name"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/admin/bizneset">Bizneset</Link>
      <span class="text-indigo-400 font-medium">/</span>

      {{ form.name }}

    </h1>

    <trashed-message v-if="business.deleted_at" class="mb-6" @restore="restore"> Ky biznes është fshirë nga sistemi.
    </trashed-message>

    <div class="flex flex-wrap  space-y-4 lg:flex-nowrap lg:space-x-4 lg:space-y-0 mb-8 mt-5">
      <div class=" bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <form @submit.prevent="update">

          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <h1 class="text-xl font-bold pb-8 pr-6 w-full lg:w-full">Të dhënat e biznesit</h1>

            <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Emri i biznesit"
            />
            <text-input v-model="form.owner_name" :error="form.errors.owner_name" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Pronari" :disabled="true"
            />
            <text-input v-model="form.number" :error="form.errors.number" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Numri i biznesit"
            />
            <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2"
                        label="Telefoni i biznesit"
            />
          </div>


          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <button v-if="user.role === 'superadmin' && !business.deleted_at " class="text-red-600 hover:underline"
                    tabindex="-1" type="button" @click="destroy"
            >Fshij
            </button>
            <button v-if="user.role === 'superadmin' && business.deleted_at " class="text-red-600 hover:underline"
                    tabindex="-1" type="button" @click="forceDelete"
            >Fshij përgjithmonë
            </button>
            <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Edito</loading-button>
          </div>
        </form>
      </div>

      <div class=" bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <h1 class="text-xl font-bold pb-8 pr-6 w-full lg:w-full">Konfigurimi i barazimeve</h1>
          <select-input v-model="barazimConfigForm.barazim_periodicity_type" class="pb-8 pr-6 w-full" label="Perioda">
            <option :value="null">Sipas dëshirës</option>
            <option v-for="(value,key) in periodicityTypes" :key="key" :value="key">{{ value }}</option>
          </select-input>

<!--          <select-input v-model="barazimConfigForm.barazim_periodicity_week_days" class="pb-8 pr-6 w-full" label="Ditët e javës">-->
<!--            <option :value="1">E hënë</option>-->
<!--            <option :value="2">E martë</option>-->
<!--            <option :value="3">E mërkurë</option>-->
<!--            <option :value="4">E enjte</option>-->
<!--            <option :value="5">E premte</option>-->
<!--            <option :value="6">E shtunë</option>-->
<!--            <option :value="7">E diele</option>-->
<!--          </select-input>-->

          <div class="pb-8 pr-6 w-full">
          <label class="form-label text-gray-700">Ditët e javës</label>
          <Multiselect
            v-model="barazimConfigForm.barazim_periodicity_week_days"
            :options="weekDays.options"
            mode="tags"
            :close-on-select="false"
            :searchable="true"
            :create-option="false"
            :classes="{containerActive: 'focus:ring-0 hover:border-indigo-500'}"
          />
            <div v-if="barazimConfigForm.errors.barazim_periodicity_week_days" class="form-error">{{ barazimConfigForm.errors.barazim_periodicity_week_days }}</div>
          </div>

        </div>

        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="barazimConfigForm.processing" class="btn-indigo ml-auto" type="button" @click="updateBarazimConfig">Edito</loading-button>
        </div>
      </div>
    </div>

    <h2 class="mt-12 mb-5 text-2xl font-bold">Lokacionet</h2>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="filterForm.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block mt-4 text-gray-700">Aktivë:</label>
        <select v-model="filterForm.trashed" class="form-select mt-1 w-full">
          <option :value="null">Aktivë</option>
          <option value="only">Joaktivë</option>
          <option value="with">Të gjithë</option>
        </select>
      </search-filter>

      <Link class="btn-indigo" :href="route('admin.businesses.locations.create',{business: this.business.id})">
        <span>Regjistro</span>
        <span class="hidden md:inline"> Lokacion të ri</span>
      </Link>
    </div>

    <div id="businesses" class="mt-6 bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Emri i lokacionit</th>
          <th class="pb-4 pt-6 px-6">Qyteti</th>
          <th class="pb-4 pt-6 px-6">Adresa</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="location in business.locations.data" :key="location.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                  :href="`/admin/bizneset/${business.id}/lokacionet/${location.id}/edit`"
            >
              {{ location.name }}
              <icon v-if="location.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>
              <icon v-if="location.primary" name="primary" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>

            </Link>
          </td>

          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                  :href="`/admin/bizneset/${business.id}/lokacionet/${location.id}/edit`"
            >
              {{ location.city.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                  :href="`/admin/bizneset/${business.id}/lokacionet/${location.id}/edit`"
            >
              {{ location.address }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                  :href="`/admin/bizneset/${business.id}/lokacionet/${location.id}/edit`"
            >
              {{ location.hr_created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                  :href="`/admin/bizneset/${business.id}/lokacionet/${location.id}/edit`"
            >
              {{ location.hr_updated_at }}
            </Link>
          </td>
        </tr>
        <tr v-if="business.locations.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje lokacion.</td>
        </tr>
        </tbody>
      </table>
    </div>


    <h2 class="mt-12 text-2xl font-bold">Çmimet</h2>
    <div id="pricing" class="mt-6 bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Shteti</th>
          <th class="pb-4 pt-6 px-6">Madhësia</th>
          <th class="pb-4 pt-6 px-6">Çmimi i transportit</th>
          <th class="pb-4 pt-6 px-6">Çmimi i anulimit</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="pricing in business.pricings.data" :key="pricing.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500"
                  :href="`/admin/bizneset/${business.id}/cmimet/${pricing.id}/edit`"
            >
              {{ pricing.country_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/admin/bizneset/${business.id}/cmimet/${pricing.id}/edit`"
                  tabindex="-1"
            >
              {{ pricing.package_size_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-12 py-4"
                  :href="`/admin/bizneset/${business.id}/cmimet/${pricing.id}/edit`" tabindex="-1"
            >
              {{ pricing.shipping_price }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-12 py-4"
                  :href="`/admin/bizneset/${business.id}/cmimet/${pricing.id}/edit`" tabindex="-1"
            >
              {{ pricing.cancellation_price }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/admin/bizneset/${business.id}/cmimet/${pricing.id}/edit`"
                  tabindex="-1"
            >
              {{ pricing.hr_created_at }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/admin/bizneset/${business.id}/cmimet/${pricing.id}/edit`"
                  tabindex="-1"
            >
              {{ pricing.hr_updated_at }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/admin/bizneset/${business.id}/cmimet/${pricing.id}/edit`"
                  tabindex="-1"
            >
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </Link>
          </td>
        </tr>
        <tr v-if="business.pricings.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnjë çmim.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {Head, Link, usePage} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import {computed} from 'vue'
import TrashedMessage from '@/Shared/TrashedMessage'
import Icon from '@/Shared/Icon'
import SearchFilter from '@/Shared/SearchFilter'
import mapValues from 'lodash/mapValues'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import Dropdown from '@/Shared/DropdownMenu'
import SearchInput from '@/Shared/SearchInput'
import Multiselect from '@vueform/multiselect'


export default {
  components: {
    SearchInput,
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Icon,
    SearchFilter,
    Dropdown,
    Multiselect
  },
  layout: Layout,
  props: {
    business: Object,
    filters: Object,
    periodicityTypes: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        id: this.business.id,
        name: this.business.name,
        owner_name: this.business.owner_name,
        number: this.business.number,
        phone: this.business.phone,
      }),
      barazimConfigForm: this.$inertia.form({
        id: this.business.id,
        barazim_periodicity_type: this.business.barazim_periodicity_type,
        barazim_periodicity_week_days: this.business.barazim_periodicity_week_days ?? []
      }),
      weekDays: {
        options: [
          {value: 1,label: 'E hënë'},
          {value: 2,label: 'E martë'},
          {value: 3,label: 'E mërkurë'},
          {value: 4,label: 'E enjte'},
          {value: 5,label: 'E premte'},
          {value: 6,label: 'E shtunë'},
          {value: 0,label: 'E diel'},
        ]
      },
      filterForm: {
        // search: this.filters.search,
      },
    }
  },
  watch: {
    filterForm: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/admin/bizneset/${this.business.id}/edit`, pickBy(this.filterForm), {preserveState: true})
      }, 150),
    },
  },
  methods: {
    update() {
      this.form.put(`/admin/bizneset/${this.business.id}`)
    },
    updateBarazimConfig(){
      this.barazimConfigForm.put(`/admin/bizneset/${this.business.id}/barazim-config`)
    },
    destroy() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/admin/bizneset/${this.business.id}`)
      }
    },
    restore() {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.put(`/admin/bizneset/${this.business.id}/restore`)
      }
    },
    forceDelete() {
      if (confirm('Ky veprim është i pakthyeshëm, shitësi nuk mund të kthehet më pas këtij veprimi. A jeni të sigurt se me të vërtetë dëshironi ta fshini këtë shitës?')) {
        this.$inertia.put(`/admin/bizneset/${this.business.id}/forceDestroy`)
      }
    },
    reset() {
      this.filterForm = mapValues(this.filterForm, () => null)
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return {user}
  },
}
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
